import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const options = {
  // order and from where user language should be detected
  order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],

  // keys or params to lookup language from
  lookupQuerystring: 'lng',
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,

  // cache user language on
  caches: ['localStorage', 'cookie'],
  excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

  // optional expire and domain for set cookie
  cookieMinutes: 10,
  cookieDomain: 'myDomain',

  // optional htmlTag with lang attribute, the default is:
  htmlTag: document.documentElement,
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // in local - comment out cimode line to translate site
    // lng: 'cimode',
    load: 'languageOnly',
    backend: {
      // translation filepath
      loadPath: '/translations/i18n/{{ns}}/{{lng}}.json',
    },
    // comment out fallback to check if any are un-translated or missing keys & LEAVE IN on prod
    fallbackLng: 'en',
    debug: false,
    // namespaces declared here will be loaded on app load as they are used across the site in different areas, specific namespaces are loaded at component level
    ns: ['common', 'auth', 'regex'],
    detection: options,
    supportedLngs: ['en'],
    nonExplicitSupportedLngs: true,
    react: {
      useSuspense: false,
      wait: false,
    },
  });

export default i18n;
